// Authenticated fetch helper with automatic 401 → /auth/refresh → retry-once logic.
// Keeps EnglishPractice / MathsPractice resilient to access_token expiry during long sessions.

import API_URL from './apiUrl';

let refreshInFlight = null;

async function refreshTokenOnce() {
  if (refreshInFlight) return refreshInFlight;
  refreshInFlight = fetch(`${API_URL}/api/auth/refresh`, {
    method: 'POST',
    credentials: 'include',
  })
    .then((r) => r.ok)
    .catch(() => false)
    .finally(() => {
      // Allow another refresh cycle next time a 401 hits
      setTimeout(() => { refreshInFlight = null; }, 50);
    });
  return refreshInFlight;
}

/**
 * fetch() wrapper that:
 *  - Always sends cookies
 *  - On 401, tries /api/auth/refresh once, then retries the original request
 */
export async function authFetch(input, init = {}) {
  const opts = { credentials: 'include', ...init };
  let res = await fetch(input, opts);
  if (res.status === 401) {
    const ok = await refreshTokenOnce();
    if (ok) {
      res = await fetch(input, opts);
    }
  }
  return res;
}

export default authFetch;
